import {GroupPageWithText} from '../GroupPageWithText';

export const ExpiredLink = () => {
  return <GroupPageWithText text="Link has Expired" />;
};
